export enum MenuItemType {
  Dprs,
  ProjectSetup,
  Clients,
  SystemAdmins,
  ProjectAdmin,
  Users,
}
